import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { useProgramFilters } from '../store/program-filters';
import { TProgram, TProgramPost } from '../types';

export async function postProgram(body: TProgramPost): Promise<TProgram> {
  return mediaManagerClient.post('/api/v1/programs', emptyStringValues(body));
}

type MutationFn = typeof postProgram;

type TUsePostProgramParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePostProgram({ config = {} }: TUsePostProgramParams = {}) {
  const { gte, lte, state, channel_id, priorities, channel_media_type, paginationValues } =
    useProgramFilters();
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: postProgram,
    onError(error) {
      addErrorNotification(t('No se ha podido crear el programa'));
      console.error(error);
    },
    onSuccess(data, variables, context) {
      config.onSuccess?.(data, variables, context);
      addSuccessNotification(t('El programa se ha creado'));
      queryClient.invalidateQueries({
        queryKey: [
          'programs',
          {
            gte,
            channel_id,
            lte,
            state,
            priorities,
            channel_media_type,
            ...Object.values(paginationValues || {}),
          },
        ],
      });
    },
  });
}
